import { Selector } from '../../lib/generated/zeus';

export const noteShiftChangeSelector = Selector('NoteShiftChanges')({
  field: true,
  from: true,
  to: true,
});

const noteMetadataSelector = Selector('NoteMetadata')({
  shift: {
    changes: noteShiftChangeSelector,
  },
});

export const noteContentSelector = Selector('NoteContent')({
  content: true,
  date: true,
  metadata: noteMetadataSelector,
});

export const relatedNoteSelector = Selector('RelatedNote')({
  id: true,
  content: true,
  date: true,
  metadata: noteMetadataSelector,
  authorId: true,
  authorName: true,
  createdAt: true,
  updatedAt: true,
  objectId: true,
});

export const shiftRelatedNoteSelector = Selector('shift_related_note')({
  note_id: true,
  object_id: true,
  content: true,
  date: true,
  metadata: [{}, true],
  note: {
    user_id: true,
    created_at: true,
    updated_at: true,
    user: {
      display_name: true,
    },
  },
});
